import React, { useEffect, useState } from 'react'
import { MapContainer, TileLayer } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'

import { LeafletControlGeocoder, LeafletMultiplePoints, LocationTracker } from './LeafletControls'
import { EpwMapProps, StaticImageStyle, WeatherInfo } from './EpwMap.types'
import { parseCSV, sources } from './utils'
import { Toaster } from 'react-hot-toast'
import { CircleFill } from 'react-bootstrap-icons'

import './EpwMap.scss'

export const EpwMap: React.FC<EpwMapProps> = ({
  staticImageStyle = undefined,
  style = null,
  showLegend = true,
  latitude = 44,
  longitude = -35,
  onCopy = undefined,
  enableCopyToClipboard = false,
  widgetStyle = { border: '2px solid rgba(125, 125, 125, 0.5)' }
}) => {
  const [data, setData] = useState<Array<WeatherInfo>>(undefined)

  const [imageStyle, setImageStyle] = useState<StaticImageStyle>({
    url:'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
    maxZoom:16
  })

  useEffect(() => {
    if (!staticImageStyle) return
    setImageStyle(staticImageStyle)
  }, [staticImageStyle])

  useEffect(() => {
    parseCSV(setData)
  }, [])

  return (
    <MapContainer center={[latitude, longitude]} zoom={3.5} style={{ height: `95vh`, ...style }}>
      <TileLayer { ...imageStyle } />
      {showLegend &&<div className='epw-general-widget epw-map-legend' style={{ ...widgetStyle }}>
        {sources.map(([name, color]) => <div key={name}>
          <CircleFill style={{ color: color, margin: '0 5px 0 0', width: '10px' }} />{name}
        </div>)}
      </div>}
      <LeafletControlGeocoder />
      <LocationTracker center={{lat: latitude, lng: longitude}} widgetStyle={widgetStyle}/>
      <Toaster />
      {data && <LeafletMultiplePoints data={data} onCopy={onCopy} enableCopyToClipboard={enableCopyToClipboard}/>}
    </MapContainer>
  )
}

export default EpwMap